import type React from "react";
import type { ReactNode } from "react";
import { VendorHeader } from "~/components/common/header/VendorHeader";
import Loading from "~/components/common/parts/loading/Loading";
import { UserLoginModal } from "~/components/common/user_login_modal/UserLoginModal";
import { useSessions } from "~/hooks/vendors/useSessions";
import { useEnabledVendorUsers } from "~/hooks/vendors/useVendorUsers";
import type { NskResponse } from "~/models/Api";
import { create as loginStaff } from "~/utils/api/vendors/sessions/VendorUser";
import { create as createVendorUserPasswordReset } from "~/utils/api/vendors/VendorUserPasswordReset";

type Props = {
	children: ReactNode;
	loginRequire?: boolean;
};

export const VendorLayoutV2: React.FC<Props> = ({
	children,
	loginRequire = true
}: Props) => {
	const { data: vendorUsers } = useEnabledVendorUsers();
	const { data: session, mutate: mutateSession } = useSessions().index();
	if (session === null || vendorUsers === null) {
		return <Loading isLoading />;
	}
	if (loginRequire && !session.admin && session.vendorUser === null) {
		// show login modal
		const handleMutateSession = async (): Promise<void> => {
			await mutateSession?.();
		};
		const handleLogin = (
			id: number,
			password: string | null
		): Promise<NskResponse> => loginStaff(id, password);
		return (
			<>
				<VendorHeader />
				<main>
					<UserLoginModal
						handleLogin={handleLogin}
						loginStaffs={vendorUsers}
						mutateSession={handleMutateSession}
						onClickForgotPassword={createVendorUserPasswordReset}
						passwordNotSetMessage="パスワードが未設定の担当者がいます。設定を推奨します。ログイン後、プロフィール画面からパスワードを設定できます。"
					/>
				</main>
			</>
		);
	}
	return (
		<>
			<VendorHeader />
			<main>{children}</main>
		</>
	);
};
